import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import UserImage from "../../assets/images/user.png";
import { get } from "lodash";
import { LogoutModal } from "../Modal";

const Layout = ({ children }) => {
	const { getMe } = useSelector((state) => state.main);
	const logoutRef = useRef();
	// console.log(getMe);

	const { t } = useTranslation();
	const navigate = useNavigate();
	const [selected, setSelected] = useState("");

	const items = [
		{
			key: "dashboardRoFood",
			icon: <MdDashboard size={20} />,
			label: "RoFood",
		},
		{
			key: "dashboardMariOlivia",
			icon: <MdDashboard size={20} />,
			label: "Mari Olivia",
		},
	];

	const onSelectMenuItem = (item) => {
		navigate(`/${item.key}`);
		localStorage.setItem("selectedMenu", item.key);
		setSelected(item.key);
	};

	useEffect(() => {
		const storedSelection = localStorage.getItem("selectedMenu");
		if (storedSelection) {
			setSelected(storedSelection);
		}
	}, []);

	const logout = () => {
		localStorage.removeItem("token");
		navigate("/login");
		localStorage.removeItem("selectedMenu");
	};

	return (
		<div className="w-full h-screen ">
			<div className="w-screen flex  justify-between items-center drop-shadow-xl p-2 bg-white ">
				<div className="flex gap-5 items-center ml-1">
					{items.map((item) => {
						return (
							<div
								key={item.key}
								className={`flex gap-2 items-center cursor-pointer p-2 ${
									selected === item.key ? "text-blue-600 bg-blue-100" : ""
								} hover:text-blue-500 `}
								onClick={() => onSelectMenuItem(item)}
							>
								{item.icon}
								<p className="text-lg font-semibold hover:text-blue-600 ">{item.label}</p>
							</div>
						);
					})}
				</div>
				<div className="flex items-center">
					<div>
						<p className="text-[#0a4d68] text-lg font-bold">
							{get(getMe, "lastName", t("Name"))} {get(getMe, "firstName", t("Name"))}
						</p>
						<p className="userPhone">
							{get(getMe, "jobTitle", t("Name")) === "prodmanager" ? t("Supermarket menejeri") : ""}
						</p>
					</div>
					<img
						src={UserImage}
						alt="userimage"
						className="w-10 h-10 rounded-full border-[1px] cursor-pointer  border-blue-900 p-1 ml-2"
						onClick={() => logoutRef.current?.open()}
					/>
				</div>
			</div>
			{children}
			<LogoutModal
				getRef={(r) => {
					logoutRef.current = r;
				}}
				onConfirm={logout}
			/>
		</div>
	);
};

export default Layout;
